import React from 'react';
import { ALLOWED_URLS } from '../../../../../../components/App/footer/LinksFooter';
import { getPolyglot } from '../../../../../../i18n';
import Link from '../../../../../../theme/components/Link';
import { StyledMenuItemPrimary } from '../../../../../../components/App/header/AvatarMenu/AvatarMenu';
export const AvatarLinksFF = (props: {
  urlAboutUs: string;
  urlStatus: string;
}) => {
  const polyglot = getPolyglot();
  const { urlStatus } = props;
  const predefinedLinks = {
  
    [ALLOWED_URLS.IMPRESSUM]: {
      label: polyglot.t('footer.impressum'),
      to: 'https://www.foursfringand.com/fr/mentions-legales/',
      external: true,
    },
    [ALLOWED_URLS.TERMS_AND_CONDITIONS]: {
      label: polyglot.t('footer.terms_and_conditions'),
      to: 'foursfringand.com/en/terms-and-conditions/',
      external: false,
    },
    [ALLOWED_URLS.COOKIE_POLICY]: {
      label: polyglot.t('footer.cookie_policy'),
      to: 'https://www.foursfringand.com/fr/politique-confidentialite/',
      external: true,
    },
    [ALLOWED_URLS.ABOUT_US]: {
      label: polyglot.t('footer.about_us'),
      to: 'https://www.foursfringand.com/en/lentreprise-fringand/',
      external: true,
    },
  };

  return (
    <>
      {Object.keys(predefinedLinks).map((key) => {
        const link = predefinedLinks[key as keyof typeof predefinedLinks];
        return (
          <Link
            key={key}
            to={link.to}
            target={link.external ? '_blank' : '_self'}
          >
            <StyledMenuItemPrimary>{link.label}</StyledMenuItemPrimary>
          </Link>
        );
      })}
      <Link to={urlStatus} target="_blank">
        <StyledMenuItemPrimary>
          {polyglot.t('footer.status')}
        </StyledMenuItemPrimary>
      </Link>
    </>
  );
};
